import { Input } from '@windmill/react-ui'
import { useFormikContext } from 'formik'
import { useMemo } from 'react'
import { kebabCase } from 'lodash'

import styles from './Input.module.css'

const TextBox = ({
    id,
    name,
    placeholder,
    label,
    disabled,
    type = 'text',
    ariaLabel,
}) => {
    const { handleBlur, handleChange, getFieldMeta } = useFormikContext() || {}
    const { value, error, touched } = getFieldMeta ? getFieldMeta(name) : {}
    const id$ = useMemo(() => id || `${kebabCase(label)}`, [id, label])

    return (
        <div className={styles.inputModule}>
            <div className={styles.formGroup}>
                <label htmlFor={id$}>{label}</label>
                <Input
                    id={id$}
                    name={name}
                    type={type}
                    disabled={disabled}
                    className={`${styles.formControl} ${
                        error && touched ? styles.hasError : ''
                    }`}
                    aria-label={ariaLabel ? ariaLabel : label}
                    placeholder={placeholder}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={value}
                />
            </div>
        </div>
    )
}

export default TextBox
